
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("contact/contact_empty",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"emptystateblock flexcenter flexcol\" style=\"height:100%\"><img src=\"/images/empty_state_illustration_contact.svg\"><h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"contact.empty.title",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":128},"end":{"line":1,"column":160}}})) != null ? stack1 : "")
    + "</h1><p class=\"blockmargin\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"contact.empty.text",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":188},"end":{"line":1,"column":219}}})) != null ? stack1 : "")
    + "</p><button data-fw-onclick=\"contactnew\"> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"contact.empty.button",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":261},"end":{"line":1,"column":294}}})) != null ? stack1 : "")
    + " </button></div> ";
},"useData":true});
export default TPL;